import { useEffect } from 'react';
import { Services, About, Wherehouse, Gallery } from './components';
import FadeCarousel from 'src/pages/home/components/hero/FadeCarousel';
import AOS from 'aos';



const Home = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);


    return (<div>
        <FadeCarousel />
        <About />
        <Services />
        <Wherehouse />
        <Gallery />
    </div>
    )
}


export default Home;